import angular from 'angular';

import UserImageComponent from './user-image.cmpt';

export default angular
    .module('application.component.user-image', [])
    .component(UserImageComponent.selector, UserImageComponent);



// WEBPACK FOOTER //
// ./src/application/component/user-image/index.js